module.exports = __webpack_public_path__ + "img/proyecto_8.2ab934d1.webp";